import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import './Info.css';
import 'react-loading-skeleton/dist/skeleton.css';

function Info() {
  const reduxState = useSelector((state) => state);

  const {
    quote: {
      destiny, program, timeExpend, accommodations,
    },
    accommodations: accommodationsPriceHash,
    courses,
    payments: { totalDiscountPercentage },
  } = reduxState;

  const renderAccommodations = () => (
    accommodationsPriceHash.length === 0
      ? <Skeleton />
      : <p className="my-0">{`Acomodação: ${accommodationsPriceHash[0].name} (${accommodationsPriceHash[0].timeExpend})`}</p>
  );

  return (
    <section className="d-flex flex-column justify-content-between">
      {
        courses.length === 0
          ? <Skeleton style={{ marginBottom: '1rem' }} height="100px" />
          : (
            <figure
              id="destiny-img"
              style={{ backgroundImage: `url(${courses[0].image})` }}
            />
          )
      }

      <article id="info" className={`d-flex justify-content-between py-1 ${(totalDiscountPercentage > 0 || courses.length === 0) ? 'bottom-division-border' : 'my-3'}`}>
        <h2 className="blue my-auto w-50">{`Intercâmbio ${destiny}`}</h2>
        <div className="w-50 d-flex flex-column justify-content-around">
          <p className="my-0">{`Destino: ${destiny}`}</p>
          <p className="my-0">{`Programa: ${program} (${timeExpend})`}</p>
          { accommodations.length > 0 && renderAccommodations() }
        </div>
      </article>
    </section>
  );
}

export default Info;
